import React from 'react';
import createAtomicBlockButton from '../InlineToolbar/utils/createAtomicBlockButton';
import Media from '../../icons/Media';

const services = [
  createAtomicBlockButton({
    help: 'Media',
    blockType: 'media',
    entityJson: {
      type: 'media',
      mutability: 'IMMUTABLE',
      data: {
        uuid: null,
      },
    },
    children: <Media fontSize="small" />,
    addCaption: true,
  }),
];

export default services;
